import { Injectable } from '@angular/core';
import cssVars from 'css-vars-ponyfill';
import { darkTheme, lightTheme } from '../../../assets/styles/Themes';
import { ITheme } from '../interfaces/ITheme';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    public setTheme(mode: 'light' | 'dark'): void {
        document.querySelector('html')?.setAttribute('theme', mode);
        this.setColorVariables(mode === 'dark' ? darkTheme : lightTheme);
    }

    private setColorVariables(colorPalette: ITheme): void {
        const root = document.documentElement;
        root.style.setProperty('--colorGrey', colorPalette.colorGrey);

        cssVars({
            variables: {
                ...colorPalette
            }
        });
    }
}
